import { render } from "./ImageProcess.vue?vue&type=template&id=cd4afe8c&scoped=true&ts=true"
import script from "./ImageProcess.vue?vue&type=script&lang=ts"
export * from "./ImageProcess.vue?vue&type=script&lang=ts"

import "./ImageProcess.vue?vue&type=style&index=0&id=cd4afe8c&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd4afe8c"]])

export default __exports__